import React, { useCallback, useRef, useState } from 'react';
import moment from 'moment';

import Filter from '@/pages/dashboard/components/NewFilter';
import { timeRange } from '@/pages/dashboard/pages/engagement/_config';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { useSelector } from 'umi';
import { formatDateFromFilterValue } from '../../utils/formatDate';
import { FORM_MAP } from '../../utils/_config/constant';
import { getDateDefault } from '../../utils/dateUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const RetentionNightingaleFilter = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit, openSticky = false, path,
    children, isHaveFilterSave, timeZone = 0 } = props;
  // daily筛选器继承逻辑
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const seasonInfo = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] }
  );
  // 设置inputList
  const [inputList] = useState([
    {
      type: 'rangeDaily',
      key: 'rangeTime',
      default: getDateDefault({ timeType: 'day', timeZone, startNum: 14, endNum: 1 }),
      extraShortcut: seasonInfo
    },
  ]);
  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value, inputList, isHaveExtendFIlter) => {
    filterValueRef.current = value;
    filterInit({
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      timeType: 'Day',
      [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter
    });
    setFilterLoading(false);
  }, [filterInit]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const obj: any = {
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      timeType: 'Day',
      [FORM_MAP.RANGE_TIME_DIFF]: false,
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'));
  }, [filterConfirm]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const obj = {
      ...(formatDateFromFilterValue(value, 'Day') || {}),
      timeType: 'Day',
      [FORM_MAP.RANGE_TIME_DIFF]: true,
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, formatDateFromFilterValue(value, 'Day'), true);
  }, [filterReset]);


  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      path={path}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={onInit}
      onConfirm={onConfirm}
      onReset={onReset}
      isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
};

export default RetentionNightingaleFilter;
